import { Component, Input, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogContent
} from "@angular/material/dialog";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { Skill } from "@app/models/rest/skill";
import { SkillStore } from "@app/services/store/skill-store";
import {
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { SkillRuleStore } from "@app/services/store/skill-rule-store";
import { SkillRule } from "@app/models/rest/skill-rule";
import { SkillProficiency } from "@app/models/enums/skill-proficiency.enum";
import { MatFormField } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-skill-rule-add",
  templateUrl: "./skill-rule-add.component.html",
  styleUrls: ["./skill-rule-add.component.scss"],
  imports: [
    FormsModule,
    MatFormField,
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    MatDialogActions,
    MatDialogContent,
    MatButton,
    DialogHeaderComponent
  ]
})
export class SkillRuleAddComponent implements OnInit {
  private activeRoute = inject(ActivatedRoute);
  protected store = inject<Store<any>>(Store);
  dialog = inject(MatDialog);
  skillProfileStore = inject(SkillProfileStore);
  skillStore = inject(SkillStore);
  skillRuleStore = inject(SkillRuleStore);
  dialogRef = inject<MatDialogRef<SkillRuleAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  SkillFC = new UntypedFormControl();
  SkillProfFC = new UntypedFormControl();
  skill: Skill;
  skills: Skill[] = [];
  skillProfile: SkillProfile;
  @Input()
  skillRule: SkillRule;

  constructor() {
    const data = this.data;

    // console.log(data);
    this.skillProfile = data.resource;
    // super(activeRoute, store, dialog);
  }

  ngOnInit() {
    this.skillStore
      .loadAll({ params: { projection: "detail" } })
      .then((skills) => {
        this.skills = skills.resources;
        this.SkillFC.setValue(this.skill);
        // this.SkillProfFC.setValue(this.skillRule.skillProficiency);
      });
  }

  async addSkillRule() {
    console.log("select");
    // console.log(this.skillSelect.selectedOptions.selected);

    // this.processNextSkillLink(this.skillSelect.selectedOptions.selected);

    const skillRule: SkillRule = new SkillRule();
    skillRule.skillProfile = this.skillProfile;
    skillRule.skill = this.SkillFC.value;
    skillRule.skillProficiency = SkillProficiency.REQUIRED;
    this.skillRuleStore.create(skillRule).subscribe(
      (value) => console.log(value),
      (error1) => console.log(error1)
    );
    this.dialog.closeAll();

    this.dialogRef.afterClosed().subscribe((result) => {
      console.log("success");
      this.ngOnInit();
    });
  }

  // public processNextSkillLink(skills: MatListOption[]) {
  //   const skil1: Skill = skills.pop().value;
  //   this.skillRule
  //     .updateRelation('skillList', skil1)
  //     .subscribe(value => {
  //       console.log('skill relation added');
  //       console.log(value);
  //       this.skillRuleStore.loadSingle(this.skillRule.skill.id, null, 'detail').then(refreshedSkill => {
  //         this.skill = refreshedSkill;
  //         if (skills.length > 0) {
  //           this.processNextSkillLink(skills);
  //         } else {
  //           // this.ngOnInit();
  //           this.dialogRef.close();
  //         }
  //       });
  //
  //     });
  // }

  async onCancelClick() {
    this.dialogRef.close();
  }
}
